import React, { useEffect, useState } from 'react';
import { firestore } from '../contexts/FirebaseContext';

function useUserListRole(id) {
  const [role, setRole] = useState('usuario');

  useEffect(() => {
    async function getRole() {
      await firestore
        .collection('users')
        .doc(id)
        .onSnapshot((queryS) => {
          //   console.log(queryS.data());
          if (queryS.exists) {
            setRole(queryS.data().role);
          }
        });
    }
    getRole();
  }, [id]);
  return role;
}

export default useUserListRole;
